import type { EmailStarterTemplate } from '../types'

/**
 * Empathetic refund confirmation — reassures the customer, confirms the
 * amount + timing, and keeps the door open for a future purchase.
 */
export const orderRefundedStarter: EmailStarterTemplate = {
    id: 'order-refunded-classic',
    label: 'Refund confirmed',
    description:
        'Confirms a refund with a calm, empathetic tone and clear timing.',
    icon: 'RotateCcw',
    accent: '#0ea5e9',
    defaultSubject: 'Your refund is on its way, {{ customerFirstName }}',
    defaultPreheader:
        'We just issued your refund. It should appear in your account within a few business days.',
    doc: {
        type: 'doc',
        content: [
            {
                type: 'heading',
                attrs: { level: 1, textAlign: 'left' },
                content: [{ type: 'text', text: 'Your refund is on its way' }],
            },
            {
                type: 'paragraph',
                content: [
                    { type: 'text', text: 'Hi ' },
                    {
                        type: 'emailVariable',
                        attrs: {
                            key: 'customerFirstName',
                            label: 'customerFirstName',
                            fallback: 'there',
                            required: false,
                        },
                    },
                    {
                        type: 'text',
                        text: ', we just issued a refund for your order. Depending on your bank, it can take a few business days to appear back on your statement.',
                    },
                ],
            },
            {
                type: 'paragraph',
                content: [
                    {
                        type: 'text',
                        marks: [{ type: 'bold' }],
                        text: 'Order: ',
                    },
                    {
                        type: 'emailVariable',
                        attrs: {
                            key: 'orderNumber',
                            label: 'orderNumber',
                            fallback: '',
                            required: true,
                        },
                    },
                    { type: 'hardBreak' },
                    {
                        type: 'text',
                        marks: [{ type: 'bold' }],
                        text: 'Refunded amount: ',
                    },
                    {
                        type: 'emailVariable',
                        attrs: {
                            key: 'refundAmount',
                            label: 'refundAmount',
                            fallback: '',
                            required: false,
                        },
                    },
                ],
            },
            { type: 'emailSpacer', attrs: { height: 12 } },
            {
                type: 'paragraph',
                content: [
                    {
                        type: 'text',
                        text: 'If anything looks off or you have questions, just reply to this email — a real person will get back to you within one business day.',
                    },
                ],
            },
            {
                type: 'paragraph',
                content: [
                    { type: 'text', text: 'Thanks for giving us a try,' },
                    { type: 'hardBreak' },
                    { type: 'text', marks: [{ type: 'bold' }], text: 'The ' },
                    {
                        type: 'emailVariable',
                        attrs: {
                            key: 'storeName',
                            label: 'storeName',
                            fallback: 'team',
                            required: false,
                        },
                    },
                    { type: 'text', marks: [{ type: 'bold' }], text: ' team' },
                ],
            },
        ],
    },
}
